export default "__VITE_ASSET__D5g8RIfO__"